import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import RfqBanner from "../components/RfqBanner";
import { PageBanner } from "./About";
import { CAPABILITIES } from "../data/content";

const Capabilities = () => (
  <>
    <PageBanner
      testId="capabilities-banner"
      eyebrow="Manufacturing Capabilities"
      title="Our Capabilities"
      description="Advanced manufacturing capabilities to meet your precision requirements — all work is carried out to customer drawings and technical specifications."
    />

    <section data-testid="capabilities-list" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 space-y-16 md:space-y-20">
        {CAPABILITIES.map((cap, i) => (
          <Reveal key={cap.id}>
            <div
              data-testid={`capability-row-${cap.id}`}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center ${
                i % 2 === 1 ? "" : ""
              }`}
            >
              <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                <img
                  src={cap.img}
                  alt={cap.alt}
                  loading="lazy"
                  className="w-full aspect-[16/10] object-cover border border-slate-200"
                />
              </div>
              <div className={i % 2 === 1 ? "lg:order-1" : ""}>
                <span className="text-xs font-mono font-semibold text-[#2563EB]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">
                  {cap.name}
                </h2>
                <p className="mt-4 text-base text-slate-600 leading-relaxed">{cap.desc}</p>
                <p className="mt-3 text-sm text-slate-500 leading-relaxed">
                  Machine capacities, size ranges and achievable tolerances for this process can be
                  confirmed against your drawing at the enquiry stage.
                </p>
                <Link
                  to={`/contact?requirement=${encodeURIComponent(cap.name)}`}
                  data-testid={`capability-enquire-button-${cap.id}`}
                  className="mt-6 inline-flex items-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-sm font-semibold px-6 py-3 rounded-sm transition-colors duration-150"
                >
                  Enquire Now <ArrowRight size={15} />
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    <RfqBanner />
  </>
);

export default Capabilities;
